import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'tidy-navbar',
    template: `
      <ion-header>
      
        <ion-toolbar [color]="color" class="toolbar-thick">
          @if (showLogo) {
            <img class="logo-white-header" src="assets/img/tidy-favicon-white.png" start>
          }
      
          @if (!hideBackButton) {
            <ion-buttons slot="start">
              <ion-back-button text=""></ion-back-button>
            </ion-buttons>
          }
      
          @if (title) {
            <ion-title>{{title}}</ion-title>
          }
      
          @if (showMenu) {
            <ion-buttons slot="primary">
              <ion-menu-toggle data-cy="menu-toggle-icon">
                <ion-button>
                  <ion-icon name="menu"></ion-icon>
                </ion-button>
              </ion-menu-toggle>
            </ion-buttons>
          }
      
        </ion-toolbar>
      
      </ion-header>
      `,
    standalone: false
})
export class TidyNavbar implements OnInit {

  @Input() title: string = null;
  @Input() showLogo = true;
  @Input() hideBackButton = false;
  @Input() showMenu = true;
  @Input() color = 'black';

  ngOnInit() {
    this.hideBackButton = this.hideBackButton || !(window.history.length > 1);
  }

}
